import { formState } from './../pages/SignIn/SignInModel';
import axiosInstance from './https';
import Instance from './https';

export const getDownloadUrl = (controller: string, action: string, section?: string) => {
   if (section) {
      return `/${controller}/${action}/${section}`;
   } else {
      return `/${controller}/${action}`;
   }
};

export const downloadItem = (
   controller: string,
   action: string,
   section?: string,
   PageNumber?: number,
   PageSize = 10,
   searchData?: Record<string, any>,
) => {
   let url = `?PageNumber=${PageNumber}&PageSize=${PageSize}`;

   if (searchData && searchData.DateFrom && searchData.DateFrom !== null && searchData.DateFrom !== undefined) {
      url += `&DateFrom=${searchData.DateFrom}`;
   }

   if (searchData && searchData.DateTo && searchData.DateTo !== null && searchData.DateTo !== undefined) {
      url += `&DateTo=${searchData.DateTo}`;
   }

   if (searchData && searchData.Actions && searchData.Actions !== null && searchData.Actions !== undefined) {
      url += `&Actions=${searchData.Actions}`;
   }

   if (
      searchData &&
      searchData.ImpactedRecord &&
      searchData.ImpactedRecord !== null &&
      searchData.ImpactedRecord !== undefined
   ) {
      url += `&ImpactedRecord=${searchData.ImpactedRecord}`;
   }

   if (
      searchData &&
      searchData.ActionTaken &&
      searchData.ActionTaken !== null &&
      searchData.ActionTaken !== undefined
   ) {
      url += `&ActionTaken=${searchData.ActionTaken}`;
   }

   if (
      searchData &&
      searchData.PatientName &&
      searchData.PatientName !== null &&
      searchData.PatientName !== undefined
   ) {
      url += `&PatientName=${searchData.PatientName}`;
   }

   if (searchData && searchData.Success && searchData.Success !== null && searchData.Success !== undefined) {
      url += `&Success=${searchData.Success}`;
   }

   if (searchData && searchData.UserId && searchData.UserId !== null && searchData.UserId !== undefined) {
      url += `&UserId=${searchData.UserId}`;
   }

   if (
      searchData &&
      searchData.DownloadOption &&
      searchData.DownloadOption !== null &&
      searchData.DownloadOption !== undefined
   ) {
      url += `&DownloadOption=${searchData.DownloadOption}`;
   }

   return axiosInstance({
      url: `${process.env.REACT_APP_BASE_API}${getDownloadUrl(controller, action, section)}${url}`,
      method: 'GET',
      responseType: 'blob',
   });
};

export const getApiUrl = (controller: string, action?: string) => {
   if (action) {
      return `${controller}/${action}/`;
   } else {
      return `${controller}`;
   }
};

export const getApiEnumUrl = (controller: string, action: string, method: string) => {
   return `${controller}/${action}/${method}`;
};

export const getAllItems = (controller: string, action: string, data: Record<string, unknown>) => {
   return Instance.post(getApiUrl(controller, action), data);
};

export const getRestUrl = (controller: string, action?: string) => {
   return `${controller}/${action}`;
};

export const userLogin = (data: formState, controller: string, action: string) => {
   return Instance.post(getRestUrl(controller, action), data);
};

export const getListItems = (
   controller: string,
   action: string,
   PageNumber?: number,
   PageSize = 10,
   searchData?: Record<string, any>,
) => {
   const searchParams: Record<string, any> = {
      PageNumber,
      PageSize,
      ...searchData,
   };

   const queries = Object.keys(searchParams).reduce((prev, current) => {
      if (!searchParams[current]) {
         return prev + '';
      }

      if (!prev) {
         return prev + `?${current}=${searchParams[current]}`;
      }

      return prev + `&${current}=${searchParams[current]}`;
   }, '');

   return Instance.get(`${getApiUrl(controller, action)}${queries}`);
};

export const getItems = (controller: string, action: string, method: string, data: Record<string, any>) => {
   return Instance.get(getApiEnumUrl(controller, action, method), data);
};

export const getList = (controller: string, action: string) => {
   return Instance.get(getApiUrl(controller, action));
};

export const getDataById = (controller: string, action: string, Id: string) => {
   return Instance.get(`${getApiUrl(controller, action)}${Id}`);
};

export const validateAddress = (controller: string, action: string, method: string, data: Record<string, any>) => {
   return Instance.post(`${getApiUrl(controller, action)}${method}`, data);
};
